import React from "react";
import { useEffect, useState, useRef } from "react";
import "./style.css";
import { BouncingLoader } from "../../pure-components/Loader";
import { Link } from "react-router-dom";
import Helper from "../../services/helper";
import defaultImage from "../../assets/default_music.png";

import { useParams } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { ErrorToast } from "../../pure-components/CustomToast";
import API from "../../services/api";
import HarvestService from "../../services/harvestService";
import MediaTile from "./media-tile";


const CatalogAlbum = (props) => {
  
  const listRef = useRef(null);
  
  const {catalogId}=useParams();
  
  useEffect(()=> {
    // console.log("catalog data : ", catalogData)
    if(!catalogId)
      toast(({ closeToast }) => <ErrorToast message={"Catalog reference missing."} />);
  },[])
  
  const [loading, setLoading] = useState(true);
  const [catalogData, setCatalogData] = useState({});
  const [albumList, setAlbumList] = useState([]);
  const lastClickedKey = "lastClickedAlbumId";

  useEffect(() => {
      (async() => {
        await loadCatalogData()
        await loadCatalogAlbumList()
      })()
    
  }, [])

  const loadCatalogAlbumList = async() => {
    setLoading(true);
    
    const reqObj = {
        refUrl : `/getalbums/{memberToken}/${catalogId}`, 
        method : 'get',
        headers : {
            "Accept" : "application/json",
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
        }
      };
    await HarvestService.loadHarvestData(reqObj).then((resp) => {
      // console.log("Albums : ", resp);
      const tempData = resp.Albums;
      if(tempData?.length > 0)
        tempData.sort((a, b) => {
          const dateA = new Date(a.ReleaseDate);
          const dateB = new Date(b.ReleaseDate);
          return dateB.getTime() - dateA.getTime(); // Sorts in descending order
        })
      setAlbumList(tempData);
    }).catch((err) => {
      console.log("Catalog Albums Loading Error : ", err);
      toast(({ closeToast }) => <ErrorToast message={"Catalog Album list loading Error."} />);
    }).finally(() => {
      setLoading(false);
    })
  }

  const loadCatalogData = async() => {
    setLoading(true);
    
    const reqObj = {
      refUrl : `/getlibrary/{memberToken}/${catalogId}`, 
      method : 'get',
      headers : {
          "Accept" : "application/json",
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
      }
    };
    await HarvestService.loadHarvestData(reqObj).then((resp) => {
      // console.log("Library : ", resp);
      setCatalogData(resp.Library);
    }).catch((err) => {
      console.log("Catalog Data Loading Error : ", err);
      toast(({ closeToast }) => <ErrorToast message={"Catalog Data loading Error."} />);
    }).finally(() => {
      setLoading(false);
    })
  }

  // Scroll to last clicked item after list loads

  const scrollToItem = (id) => {
    const el = document.getElementById(`${id}`);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  };
  useEffect(() => {
    if (albumList.length === 0) return;

    const lastClickedId = sessionStorage.getItem(lastClickedKey);
    if (!lastClickedId) return;

    // wait for images
    const container = listRef.current;
    const images = container.querySelectorAll("img");

    let loadedCount = 0;

    if (images.length === 0) {
      scrollToItem(lastClickedId);
      return;
    }

    images.forEach((img) => {
      if (img.complete) {
        loadedCount++;
        if (loadedCount === images.length) scrollToItem(lastClickedId);
      } else {
        img.onload = () => {
          loadedCount++;
          if (loadedCount === images.length) scrollToItem(lastClickedId);
        };
        img.onerror = () => {
          loadedCount++;
          if (loadedCount === images.length) scrollToItem(lastClickedId);
        };
      }
    });
  }, [albumList]);
 
  return (
    
    <div ref={listRef} 
      className="sm:flex sm:flex-col sm:w-full lg:mx-auto p-5 bg-bg rounded-2xl"
      style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))", minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll" }}
    >
      
    {(!loading && catalogData && 
      <div className="p-1">
        <div className="flex flex-col md:flex-row">
          <div className="w-full lg:w-2/12 rounded-md">
            <div className="image-container max-w-xs mx-auto md:mt-0 lg:mx-0">
              {catalogData?.LibraryLogoUrl ? (
                <img
                  src={catalogData?.LibraryLogoUrl || defaultImage}
                  alt=""
                  onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
                  className="w-full border"
                  loading="lazy"
                  style={{ boxShadow: "4px 4px 12px rgb(var(--shadow))"}}
                />
              ) : (
                <img
                  src={defaultImage}
                  alt="Catalog img"
                  className="w-full border-b music-image justify-center align-middle"
                  loading="lazy"
                  style={{ boxShadow: "4px 4px 12px rgb(var(--shadow))"}}
                />
              )}
            </div>
          </div>
          <div 
            className="w-full lg:w-10/12 lg:pl-5"
            style={{ border: "rgb(var(--border))", color: "rgb(var(--text))", marginTop : "-6px" }}
          >
            <span className="album-header text-center md:text-left">{catalogData?.Name}</span>
            {catalogData?.Detail?.length > 0 && 
            <p className="w-full text-left notify-text mt-2">
              {catalogData?.Detail}
            </p>}
          </div>
        </div>
      </div>
    )}
    
    <div className="border-t my-2"></div>
    
    <div className="w-full">
      {loading && (
        <div className="w-full">
          <BouncingLoader />
        </div>
      )}
      {!loading && !(albumList?.length > 0) ? (
        <div className="text-lg sm:text-xl text-center text-red-500 my-5">
          No Album Found
        </div>
      ) : (
        <div 
          className="bg-white grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-2 sm:gap-2 md:gap-2 mt-2"
          style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))" }}
        >
          {albumList?.map((elem, index) => (
            <Link to={`/album/${elem?.ID}`} 
              key={elem?.ID} 
              id={elem?.ID} 
              onClick={() => {sessionStorage.setItem(lastClickedKey, elem?.ID)}}
              className="m-1"
            >
              {/* <div className="music-tile">
                <div className="image-container relative">
                  {Helper.getArtworkURL(elem?.ID)?.length > 0? (
                    <img
                      src={Helper.getArtworkURL(elem?.ID) || defaultImage}
                      alt="Album img"
                      onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
                      className="w-full border cursor-pointer object-cover aspect-square"
                      loading="lazy"
                    />
                  ) : (
                    <img
                      src={defaultImage}
                      alt="Album img"
                      className="w-full border-b cursor-pointer music-image justify-center align-middle object-cover aspect-square"
                      loading="lazy"
                    />
                  )}
                  <span className="play_icon absolute" title="Play"></span>
                </div>
                <div className="p-2">
                  <p className="text-sm font-bold line-clamp-1">{elem?.Name || elem?.DisplayTitle}</p>
                  {elem.Detail?.length > 0 &&
                    <p className="text-xs sm:text-sm font-light text-left description line-clamp-2"
                      title={elem?.Detail}
                    >
                      {elem?.Detail || elem?.DisplayTitle || elem?.Name}
                    </p>
                  }
                </div>
              </div> */}
              <MediaTile
                style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))" }}
                image={Helper.getArtworkURL(elem?.ID) || defaultImage}
                title={elem?.Name || elem?.DisplayTitle}
                code=""
                description={elem?.Detail || elem?.DisplayTitle || elem?.Name}
                id={elem.ID}
              />
            </Link>
          ))}
        </div>
      )}
      
    </div>
  </div>
  );
};

export default CatalogAlbum;